// extracted by mini-css-extract-plugin
var _1 = "Ineligible-module__button--_bj3n";
var _2 = "Ineligible-module__buttonContainer--e688x";
var _3 = "Ineligible-module__icoIneligible--OY0Vc";
var _4 = "Ineligible-module__image--Dww1F";
export { _1 as "button", _2 as "buttonContainer", _3 as "icoIneligible", _4 as "image" }
